import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './ProgressBar.module.scss.js';

var ProgressBar = function (_a) {
    var valueNow = _a.valueNow, max = _a.max, className = _a.className, style = _a.style;
    return (jsx("div", __assign({ role: "progressbar", "aria-valuenow": valueNow, "aria-valuemax": max, className: clsx(styles.progressBarWrapper, className), style: style }, { children: jsx("div", { className: styles.progressBar, "data-testid": "progress-bar", style: { width: "".concat((valueNow / max) * 100, "%") } }) })));
};

export { ProgressBar };
